import { boolean, schema } from "@anna-money/anna-web-lib/serializer";

export class DirectorVerificationStatusData extends schema(
  {
    isIdvStarted: boolean(),
    isAcspFormSubmitted: boolean(),
  },
  "DirectorVerificationStatusData",
) {}
